
import { defineComponent } from 'vue'
import { FormDataStructure } from '@/contracts/forms/FieldContracts'
import { NuxeoRegistrationResponse } from '@/contracts/api/ResponseContracts'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import Heading from '@/components/Heading.vue'
import Form from '@/components/Form.vue'
import { nuxeoRegistration } from '@/composables/nuxeo'

export default defineComponent(
{
    name: 'Register',
    components:
    {
        Heading,
        Form
    },
    setup()
    {
        // Load router:
        const router = useRouter()
        // Load vuex:
        const store = useStore()
        // Set fields:
        const fields =
        {
            email:
            {
                name: 'email',
                type: 'Input',
                label: 'Email address',
                inputType: 'email',
                autocomplete: 'email',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    email:
                    {
                        config: true
                    },
                    max:
                    {
                        config: 255
                    }
                }
            },
            emailconfirm:
            {
                name: 'emailconfirm',
                type: 'Input',
                label: 'Confirm email address',
                hint: 'Please confirm your email address',
                inputType: 'email',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    confirm:
                    {
                        config: 'email'
                    }
                }
            }
        }
        // Set buttons:
        const buttons =
        {
            submit:
            {
                name: 'submit',
                type: 'Submit',
                text: 'Create account'
            }
        }
        // Handle submission:
        const saveFormData = (formData: FormDataStructure) =>
        {
            nuxeoRegistration(
            {
                email: formData.email.toLowerCase()
            },
            function(response: NuxeoRegistrationResponse)
            {
                store.commit('formData/setRegistrationData', formData)
                router.push({ name: 'RegisterActivationNotice' })
            })
        }

        // Return data:
        return {
            fields,
            buttons,
            saveFormData
        }
    }
})
